import React from 'react';
import { useHelp } from './HelpProvider';

const T = {
  rule: '#D7C9A1',
  ruleStrong: '#BFAB79',
  inkMuted: '#6E5A38',
  inkFaint: '#A39068',
  paperDeep: '#EEE2BF',
  orange: '#EA7C1F',
  full: '999px',
  sans: '"Nunito", ui-sans-serif, system-ui, sans-serif',
};

const HelpCenterButton = () => {
  const { openHelpPanel } = useHelp();

  return (
    <button
      type="button"
      onClick={openHelpPanel}
      aria-label="Open Help Center"
      title="Help (press ?)"
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: T.full,
        border: `1px dashed ${T.ruleStrong}`,
        backgroundColor: T.paperDeep,
        color: T.inkMuted,
        fontSize: '15px',
        fontWeight: 700,
        cursor: 'pointer',
        transition: 'all 150ms ease',
        flexShrink: 0,
        fontFamily: T.sans,
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = T.orange;
        e.currentTarget.style.borderColor = T.orange;
        e.currentTarget.style.color = '#fff';
        e.currentTarget.style.borderStyle = 'solid';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = T.paperDeep;
        e.currentTarget.style.borderColor = T.ruleStrong;
        e.currentTarget.style.color = T.inkMuted;
        e.currentTarget.style.borderStyle = 'dashed';
      }}
    >
      ?
    </button>
  );
};

export default HelpCenterButton;
